.atm_vy_1ns9ob4{width:fit-content;}
@media only screen and (max-width: 531px){.atm_1bxdhr2_bv7evl.atm_1bxdhr2_bv7evl{width:136px;}}
